import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Login from '../views/Login.vue'
import DefaultLayout from '../components/DefaultLayout.vue'
import CompanyEdit from '../views/CompanyList.vue'
import UserEdit from '../views/UserList.vue'
import Profile from '../views/Profile.vue'
import CompanyDetail from '../views/CompanyDetail.vue'
import UserDetail from '../views/UserDetail.vue'
import OrderList from '../views/OrderList.vue'
import MailList from '../views/MailList.vue'
import MailAdd from '../views/MailAdd.vue'
import OrderDetail from '../views/OrderDetail.vue'
import MailDetail from '../views/MailDetail.vue'
import PostList from '../views/PostList.vue'
import PostAdd from '../views/PostAdd.vue'
import PostDetail from '../views/PostDetail.vue'
import PostCategoryList from '../views/PostCategoryList.vue'
import DocumentsList from '../views/DocumentsList.vue'
import FaqList from '../views/FaqList.vue'
import FaqForm from '../views/FaqForm.vue'
import FaqDetail from '../views/FaqDetail.vue'
import PriceList from '../views/PriceList.vue'
import PriceCategoryManagement from '../views/PriceCategoryManagement.vue'
import store from '@/store'
import SubjectOfBusinessAdmin from '../views/SubjectOfBusinessAdmin.vue'
import SubjectOfBusinessCategoryAdmin from '../views/SubjectOfBusinessCategoryAdmin.vue'
import Analytics from '../views/Analytics.vue'
import OrderProfit from '../views/OrderProfit.vue'
import VhqList from '../views/VhqList.vue'
import VhqDetail from '../views/VhqDetail.vue'
import ReadyMadeCompanyList from '../views/ReadyMadeCompanyList.vue'
import ReadyMadeCompanyForm from '../views/ReadyMadeCompanyForm.vue'
import VhqManagement from '../views/VhqManagement.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: Login,
    },
    {
      path: '/dashboard',
      component: DefaultLayout,
      meta: { requiresAuth: true },
      children: [
        { path: '/profile', name: 'Profil', component: Profile },
        { path: '/dashboard', name: 'Dashboard', component: Dashboard },
        { path: '/companies', name: 'Úprava spoločností', component: CompanyEdit },
        { path: '/company-detail/:id', name: 'Detail spoločnosti', component: CompanyDetail },
        { path: '/users', name: 'Úprava klientov', component: UserEdit },
        { path: '/user-detail/:id', name: 'Detail klienta', component: UserDetail },
        { path: '/orders', name: 'Zoznam objednávok', component: OrderList },
        { path: '/order-detail/:id', name: 'Detail objednávky', component: OrderDetail },
        { path: '/mails', name: 'Zoznam zásielok', component: MailList },
        { path: '/mail-detail/:id', name: 'Detail zásielky', component: MailDetail },
        { path: '/mail-add', name: 'Pridať zásielku', component: MailAdd },
        { path: '/posts', name: 'Zoznam článkov', component: PostList },
        { path: '/post-detail/:id', name: 'Detail článku', component: PostDetail },
        { path: '/post-add', name: 'Pridať článok', component: PostAdd },
        { path: '/post-categories', name: 'Správa kategórií článkov', component: PostCategoryList },
        { path: '/documents', name: 'Doklady', component: DocumentsList },
        { path: '/faqs', name: 'Zoznam FAQ', component: FaqList },
        { path: '/faq-add', name: 'Pridať FAQ', component: FaqForm },
        { path: '/faq-detail/:id', name: 'Detail FAQ', component: FaqDetail },
        { path: '/faq-edit/:id', name: 'Upraviť FAQ', component: FaqForm },
        { path: '/prices', name: 'Správa cien', component: PriceList },
        { path: '/price-categories', name: 'Správa kategórií cien', component: PriceCategoryManagement },
        { path: '/subject-of-business', name: 'Správa predmetov podnikania', component: SubjectOfBusinessAdmin },
        { path: '/subject-of-business-categories', name: 'Správa kategórií predmetov podnikania', component: SubjectOfBusinessCategoryAdmin },
        { path: '/page-management', name: 'Správa stránok', component: () => import('../views/PageManagement.vue') },
        { path: '/analytics', name: 'Analytika', component: Analytics },
        { path: '/order-profit', name: 'Obrat z objednávok', component: OrderProfit },
        { path: '/vhq', name: 'VHQ Zoznam', component: VhqList },
        { path: '/vhq-detail/:id', name: 'VHQ Detail', component: VhqDetail },
        { path: '/vhq-management', name: 'VHQ Management', component: VhqManagement },
        { path: '/ready-made-companies', name: 'Ready made firmy', component: ReadyMadeCompanyList },
        { path: '/ready-made-company-add', name: 'Pridať ready made firmu', component: ReadyMadeCompanyForm },
        { path: '/ready-made-company-detail/:id', name: 'Upraviť ready made firmu', component: ReadyMadeCompanyForm },
      ],
    },
    {
      path: '/auth',
      redirect: '/login',
      name: 'Auth',
      meta: { isGuest: true },
      children: [{ path: '/login', name: 'Login', component: Login }],
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !store.state.user.token) {
    next({ name: 'Login' })
  } else if (store.state.user.token && to.meta.isGuest) {
    next({ name: 'Dashboard' })
  } else {
    next()
  }
})

export default router
